var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { I18nService } from '@/services/i18n-service';
import _ from 'lodash';
import { NORMAL, ONLY_TEAM_NAME, ONLY_FOLDER_NAME, DO_PATENT_IN_SAME_SPACE, DO_FOLDER_COMMENT, DO_FOLDER_GROUP_SHARE, DO_PATENT_SOMETHING, DO_USER_NAMES, DO_FOLDER_NAMES, DO_USER_SHARE_MAP, SAVE_PATENT_WITH_QUERY } from '../constants';
const LOCAL_SPILT_SYMBOL_MAP = {
    jp: '、',
    en: ',',
    cn: '，',
    tw: '，',
};
let OperationRecordsMessageServiceImpl = class OperationRecordsMessageServiceImpl {
    constructor(_i18n) {
        this._i18n = _i18n;
    }
    getOperationRecordsMessage(key, params) {
        if (_.includes(NORMAL, key)) {
            return this._handleNormalText(key);
        }
        if (_.includes(ONLY_TEAM_NAME, key)) {
            return this._handleTeamNameText(key, params);
        }
        if (_.includes(ONLY_FOLDER_NAME, key)) {
            return this._handleFolderNameText(key, params);
        }
        if (_.includes(DO_PATENT_IN_SAME_SPACE, key)) {
            return this._handlePatentInSameSpaceText(key, params);
        }
        if (_.includes(DO_FOLDER_COMMENT, key)) {
            return this._handleCommentText(key, params);
        }
        if (_.includes(DO_FOLDER_GROUP_SHARE, key)) {
            return this._handleFolderGroupShareText(key, params);
        }
        if (_.includes(DO_PATENT_SOMETHING, key)) {
            return this._handlePatentSomeThingText(key, params);
        }
        if (_.includes(SAVE_PATENT_WITH_QUERY, key)) {
            return this._handlePatentSomeThingText(key, params);
        }
        if (_.includes(DO_USER_NAMES, key)) {
            return this._handleUserNameText(key, params);
        }
        if (_.includes(DO_FOLDER_NAMES, key)) {
            return this._handleDupFolderNameText(key, params);
        }
        if (_.includes(DO_USER_SHARE_MAP, key)) {
            return this._handleUserShareMapText(key, params);
        }
    }
    get _splitSymbol() {
        return LOCAL_SPILT_SYMBOL_MAP[this._i18n.locale] || LOCAL_SPILT_SYMBOL_MAP['en'];
    }
    _listToStr(list) {
        if (!list || !list.length)
            return '';
        return list.join(this._splitSymbol);
    }
    /**
     * 直接展示文本
     */
    _handleNormalText(key) {
        return this._i18n.t(`Record.recordDetail.${key}`);
    }
    /**
     * 只展示teamName
     */
    _handleTeamNameText(key, params) {
        const list = _.map(params.groupNameList);
        return this._i18n.t(`Record.recordDetail.${key}`, {
            teamName: _.escape(this._listToStr(list)),
            folderName: _.escape(params.folderName),
        });
    }
    /**
     * 只展示folderName
     */
    _handleFolderNameText(key, params) {
        return this._i18n.t(`Record.recordDetail.${key}`, {
            folderName: _.escape(params.folderName),
        });
    }
    /**
     * 对 { *** } 做了 {***} 条专利 { *** } 做了事
     */
    _handlePatentInSameSpaceText(key, params) {
        return this._i18n.t(`Record.recordDetail.${key}`, {
            fromFolderName: _.escape(params.formFolderName),
            folderName: _.escape(params.folderName),
            num: params.patentCount,
        });
    }
    /**
     * 新建 修改 删除 注释
     */
    _handleCommentText(key, params) {
        return this._i18n.t(`Record.recordDetail.${key}`, {
            pn: params.pn,
            comment: _.escape(params.comment),
        });
    }
    /**
     * 在folder里面对协作者/团队进行操作
     */
    _handleFolderGroupShareText(key, params) {
        const list = _.map(params.receiverNameList);
        return this._i18n.t(`Record.recordDetail.${key}`, {
            folderName: _.escape(params.folderName),
            userName: _.escape(params.userName),
            teamName: _.escape(params.teamName),
            list: _.escape(this._listToStr(list)),
        });
    }
    /**
     * 对 { *** } 条专利 { *** } 做了事
     */
    _handlePatentSomeThingText(key, params) {
        return this._i18n.t(`Record.recordDetail.${key}`, {
            folderName: _.escape(params.folderName),
            num: params.patentCount,
        });
    }
    /**
     * 对以下的人做了 [userName...]  !!拼接需要注意 cn en jp
     */
    _handleUserNameText(key, params) {
        const list = _.map(params.receiverNameList) || [];
        return this._i18n.t(`Record.recordDetail.${key}`, {
            list: _.escape(this._listToStr(list)),
        });
    }
    /**
     * 对以下的人做了 [folderName...]  !!拼接需要注意 cn en jp
     */
    _handleDupFolderNameText(key, params) {
        const list = _.map(params.folderNameList) || [];
        return this._i18n.t(`Record.recordDetail.${key}`, {
            list: _.escape(this._listToStr(list)),
        });
    }
    _handleUserShareMapText(key, params) {
        const list = params.receiverNameRoleList;
        const subStrList = [];
        _.forEach(list, item => {
            const subStr = this._i18n.t(`Record.recordDetail.${key}`, {
                folderName: _.escape(params.folderName),
                teamName: _.escape(Object.keys(item)[0]),
                userName: _.escape(Object.keys(item)[0]),
                roleType: this._i18n.t(`workspace.share.role.${item[Object.keys(item)[0]].toUpperCase()}`),
            });
            subStrList.push(subStr);
        });
        return `${this._i18n.t(`Record.prefixAndSuffix.${key}_PREFIX`, {
            folderName: _.escape(params.folderName),
        })}
        ${subStrList.join(this._splitSymbol)} 
        ${this._i18n.t(`Record.prefixAndSuffix.${key}_SUFFIX`, {
            folderName: _.escape(params.folderName),
        })}`;
    }
};
OperationRecordsMessageServiceImpl = __decorate([
    injectable(),
    __param(0, inject(I18nService)),
    __metadata("design:paramtypes", [typeof (_a = typeof I18nService !== "undefined" && I18nService) === "function" ? _a : Object])
], OperationRecordsMessageServiceImpl);
export { OperationRecordsMessageServiceImpl };
